import { Component, Vue, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import Loader from "@/components/Includes/Loader/Loader.vue";
import AppConfig from "../AppConfig/AppConfig";
import IAppConfig from "@/interfaces/astrology/appConfig/IAppConfig";
@Component({
  components: {
    Loader,
    AppConfig,
  },
})
export default class AppConfigsList extends Vue {
  @Action private readonly fetchAppConfigs!: (payload: {
    query: string;
  }) => Promise<{ links: number; data: IAppConfig[] }>;

  private appConfigs: Readonly<IAppConfig[]> = [];
  private totalPages = 0;
  private perPage = 100;
  private loading = false;
  private page = 1;
  private showedAppConfigId: number | null = null;

  @Watch("page")
  private async loadAppConfigs() {
    if (this.loading) {
      return;
    }

    this.loading = true;

    const { data, links } = await this.fetchAppConfigs({
      query: `?page=${this.page}&pagination=true&limit=${this.perPage}`,
    });

    this.appConfigs = data.map((el) => Object.freeze(el));
    this.totalPages = links;
    this.loading = false;
  }

  private get isShowAppConfig() {
    return this.showedAppConfigId !== null;
  }

  private onCreateAppConfig() {
    this.loadAppConfigs();
    this.resetShowedAppConfig();
  }

  private onChangeAppConfig() {
    this.loadAppConfigs();
    this.resetShowedAppConfig();
  }

  private onDeleteAppConfig() {
    this.page = 1;
    this.loadAppConfigs();
    this.resetShowedAppConfig();
  }

  private showCreateAppConfig() {
    this.showedAppConfigId = 0;
  }

  private resetShowedAppConfig() {
    this.showedAppConfigId = null;
  }

  private onRowClicked({ id }: IAppConfig) {
    if (id) {
      this.showedAppConfigId = id;
    }
  }

  private created() {
    this.loadAppConfigs();
  }
}
